import React from 'react';
import { Link } from 'gatsby';

import Layout from '../_layout/layout';
import SEO from '../_layout/seo';

const NotFoundPage = () => (
  <Layout>
    <SEO
      url={'404'}
      title={'NOT FOUND | 働き方情報 Clarity（クラリティ）'}
      description={'ページが見つかりません'}
    />
    {/* not found top */}
    <div className="not-found-top w-100 text-center">
      <h1 className="text-green">NOT FOUND</h1>
      <p>ページが見つかりません</p>
    </div>
    {/* not found bottom */}
    <div className="not-found-btm w-100 text-center">
      <p>
        <b>ご指定のページが見つかりませんでした。</b>
      </p>
      <p>ご指定のページは削除されたか、移動した可能性がございます。</p>
      <p className="link">
        <Link to="/">トップページへ戻る</Link>
      </p>
    </div>
  </Layout>
);

export default NotFoundPage;
